<template>
  <RouterView />
  <EventEnd v-if="commonStore.modal.name === 'EventEnd'" />
  <InvalidCountry v-if="commonStore.modal.name === 'InvalidCountry'" />
</template>

<script lang="ts">
import { RouterView } from 'vue-router';
import { useI18n } from "vue-i18n";
import { useAgentStore } from '@/stores/user'
import { useCommonStore } from '@/stores/common'
import { useIB4Store } from '@/stores/ib4-0'
import { getCookie, getCollectionId, getUtmPath } from '@/service/cookie'
import { trackId } from '@/api/track'
import { validDomain } from '@/api/valid'
import EventEnd from "@/components/Modals/EventEnd.vue";
import InvalidCountry from "@/components/Modals/InvalidCountry.vue";
import { getLocation } from './api/location';
import * as Sentry from "@sentry/vue";
import axios from "axios";

export default {
  components: {
    RouterView,
    EventEnd,
    InvalidCountry,
  },
  setup() {
    const i18n = useI18n();
    const commonStore = useCommonStore()
    const agentStore = useAgentStore()
    const ib4Store = useIB4Store()

    return {
      agentStore,
      commonStore,
      i18n,
      ib4Store
    }
  },
  // data() {
  //   return {
  //     uuid: '',
  //   }
  // },
  methods: {
    async track() {

      const collectionId = getCollectionId();

      const trackID = getCookie('track_id');

      if (collectionId !== null && trackID === null) {

        const utmPath: any = getUtmPath();

        const data = {
          "equipmentNumber": window.navigator.userAgent,
          "browseTime": this.formatDate(Date.now()),
          "domain": window.location.href,
          "collectionId": collectionId,
          "utmSource": utmPath['utm_source'] || '',
          "utmMedium": utmPath['utm_medium'] || '',
          "utmCampaign": utmPath['utm_campaign'] || '',
          "utmTerm": utmPath['utm_term'] || '',
          "utmContent": utmPath['utm_content'] || '',
          "parentUuid": "",
          "source": window.location.hostname,
          "linkCode": ""
        }

        const track = await trackId(data);
      }
    },
    async redirectEvent() {
      let token: string = window.location.href.split("token=")[1];
      //console.log('token', token)
      if (token) {

        this.$router.push(`/sc?token=${token}`)
      }
    },

    formatDate(date: Date) {
      const yyyy = new Date(date).getFullYear();
      const mm = ('0' + (new Date(date).getMonth() + 1)).slice(-2)
      const dd = ('0' + (new Date(date).getDate())).slice(-2);
      const hh = ('0' + (new Date(date).getHours())).slice(-2);
      const MM = ('0' + (new Date(date).getMinutes())).slice(-2);
      const ss = ('0' + (new Date(date).getSeconds())).slice(-2)

      return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + MM + ':' + ss;
    },
    async sentry() {
      try {
        const { data } = await getLocation();
        Sentry.setTag("country", data.country);
        Sentry.setTag("region", data.region);
        Sentry.setTag("city", data.city);
      } catch (error) {
        console.log(error)
      }

    }

  },
  created() {
    this.track();
    this.commonStore.checkCRMURL()
    this.redirectEvent();
    // this.sentry();
  },
}
</script>

<style lang="scss">
body {
  margin: inherit;
  padding: 0;
  box-sizing: border-box;
}
</style>